import React, { useState, useEffect } from 'react';
import axios from 'axios';
import qs from 'qs'; // Import qs for URL encoding
import '../Style.css';
import LogoutButton from './LogoutButton';

const TicketForm = () => {
    const [formData, setFormData] = useState({
        name: '',
        payment_method: 'Cash',
        ticket_cat: 'Student',
        amount: 500,
        reference: '', // Added reference field
        quantity: 1, // Added quantity field
        order_id: 1000, // Initialize order_id with default value
    });

    const ticketPrices = {
        Student: 500,
        General: 2500,
        Deluxe: 6000,
        Diamond: 11000,
        Stall: 0.0,
        Media: 0.0,
        VIP: 0.0,
        Delegate: 0.0
    };

    // Fetch last order_id from server
    useEffect(() => {
        axios.get('https://register.tjdstore.in/api/get_last_order_id.php')
            .then(response => {
                const lastOrderId = response.data.order_id;
                const newOrderId = parseInt(lastOrderId, 10) + 1; // Convert to number and add 1
                setFormData(prevState => ({
                    ...prevState,
                    order_id: newOrderId // Set the new order_id
                }));
            })
            .catch(error => {
                console.error('Error fetching last order ID:', error);
            });
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value,
            amount: name === 'ticket_cat' ? ticketPrices[value] * prevState.quantity : prevState.amount
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        axios.post('https://register.tjdstore.in/api/submit_ticket_new.php', qs.stringify(formData), {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        })
        .then(response => {
            alert('Form submitted successfully!');
            setFormData({
                order_id: '',
                name: '',
                payment_method: 'Cash',
                ticket_cat: 'Student',
                amount: 500,
                reference: '',
                quantity: 1 // Reset quantity field
            });
        })
        .catch(error => {
            console.error('Error:', error.response ? error.response.data : error.message);
            alert('An error occurred while submitting the form.');
        });
    };

    return (
        <div className="container topic">
            <div className='row justify-content-center'>
                <div className="col-md-6">
                    <div className="card mt-5">
                        <div className="card-body">
                        <LogoutButton/>

                            <h2 className="center">TICKET BOOKING</h2>
                            <form onSubmit={handleSubmit}>

                                <div className="mb-3">
                                    <label>Order ID:</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="order_id"
                                        value={formData.order_id}
                                        readOnly
                                    />
                                </div>  

                                <div className="mb-3">
                                    <label>Name:</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="name"
                                        value={formData.name}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>

                                <div className="mb-3">
                                    <label>Ticket Category:</label>
                                    <select
                                        name="ticket_cat"
                                        className="form-select"
                                        value={formData.ticket_cat}
                                        onChange={handleChange}>
                                        <option value="Student">Student</option>
                                        <option value="General">General</option>
                                        <option value="Deluxe">Deluxe</option>
                                        <option value="Diamond">Diamond</option>
                                        <option value="Stall">Stall</option>
                                        <option value="VIP">VIP</option>
                                        <option value="Media">Media</option>
                                        <option value="Delegate">Delegate</option>
                                    </select>
                                </div>

                                {/* Reference field for VIP category */}
                                {(formData.ticket_cat === 'VIP' || formData.ticket_cat === 'Delegate') && (
                                    <div className="mb-3">
                                        <label>Reference:</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="reference"
                                            value={formData.reference}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                )}                               

                                <div className="mb-3">
                                    <label>Quantity:</label>
                                    <input
                                        type="number"
                                        className="form-control"
                                        name="quantity"
                                        value={formData.quantity}
                                        onChange={handleChange}
                                        min="1"
                                        required
                                    />
                                </div>

                                <div className="mb-3">
                                    <label>Amount:</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="amount"
                                        value={formData.amount}
                                        readOnly
                                    />
                                </div>

                                <div className="mb-3">
                                    <label>Payment Method:</label>
                                    <select className="form-select" name="payment_method" value={formData.payment_method} onChange={handleChange}>
                                        <option value="Cash">Cash</option>
                                        <option value="Online">Online</option>
                                        <option value="None">None</option>
                                    </select>
                                </div>                            

                                <div className="mb-3">
                                    <button className="btn btn-info" type="submit"><strong>SUBMIT</strong></button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TicketForm;
